// Article Summary Toggle Functionality
const initArticleSummary = () => {
  const summaryBlocks = document.querySelectorAll(
    '[data-component="article-summary"]',
  );

  summaryBlocks.forEach((block) => {
    const toggle = block.querySelector(
      '.article-summary__toggle',
    ) as HTMLElement | null;
    const toggleText = block.querySelector('.article-summary__toggle-text');

    if (!toggle || !toggleText) return;

    const showMoreText = toggle.dataset.showMore || 'Show more';
    const showLessText = toggle.dataset.showLess || 'Show less';

    toggle.addEventListener('click', () => {
      const isExpanded = block.classList.contains('article-summary--expanded');

      if (isExpanded) {
        block.classList.remove('article-summary--expanded');
        toggle.setAttribute('aria-expanded', 'false');
        toggleText.textContent = showMoreText;
      } else {
        block.classList.add('article-summary--expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggleText.textContent = showLessText;
      }
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleSummary);
} else {
  initArticleSummary();
}
